// Module
var code = "<div class=\"field-row\"> <div class=\"head full\"> <div class=\"label\"> <label>{{ editor.options.label }}</label> <div class=\"field-description\">{{ editor.options.description }}</div> </div> <nav class=\"series-nav\"></nav> </div> <div class=\"body full\"> <div class=\"items\"></div> </div> </div> ";
// Exports
export default code;